import React from "react";
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { getCalibrationShipCount } from "../Actions/CommonAPI";
import MMPLCalibrationDueList from "./MMPLCalibrationDueList";
import Autocomplete from "react-autocomplete";
import { getShipnameList, getCompanynameList } from "../Actions/HelpersAPI";
import CountUp from "react-countup";
import axios from "axios";
import API from "../helpers/api";
import DatePicker from "react-datepicker";
import Moment from 'moment';
import swal from "sweetalert";
import Modal from "react-bootstrap/Modal";
import clear from "../Asset/clear.svg";
import "../Asset/css/dashboard.css";
import $ from "jquery";
import { parse } from "date-fns";
import FileSaver from "file-saver";

let user = JSON.parse(localStorage.getItem("currentUser"));

class DeviceCalibrationSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchShip: {
        pageNumber: 1,
        pageSize: 25,
        deviceId: "",
        shipId: 0,
        clientId: 0,
        ShipName: "",
        make: "",
        total: true,
        overDue: false,
        thirtyDaysDue: false,
        sixtyDaysDue: false,
        ninetyDaysDue: false,
        SelectedManufacturingFromDate: '',
        SelectedManufacturingToDate: '',
        fromDatePickerManufacturingIsOpen: false,
        toDatePickerManufacturingIsOpen: false,
        startDate: "",
        endDate: ""
      },
      isClient: false,
      isShipDetails: false,
    };
    this.SearchShips = this.SearchShips.bind(this);
    this.openManufacturingFromDatePicker = this.openManufacturingFromDatePicker.bind(this);
    this.openManufacturingToDatePicker = this.openManufacturingToDatePicker.bind(this);
    this.handleManufacturingFromDateChange = this.handleManufacturingFromDateChange.bind(this);
    this.handleManufacturingToDateChange = this.handleManufacturingToDateChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    const { params, path } = match;
    dispatch({ type: "SubBannerTitle", data: "Device Calibration Due" });
    if (path === "/Home/Client/Ship/DeviceCalibration/:id") {
      this.state.searchShip.shipId = parseInt(params.id);
      this.state.isShipDetails = true;
      this.state.isClient = false;
      this.setState({})
    }
    if (path === "/Home/client/DeviceCalibration/:id") {
      this.state.searchShip.clientId = parseInt(params.id);
      this.state.isClient = true;
      this.state.isShipDetails = false;
      this.setState({})
    }
    if (path === "/Home/Management/DeviceCalibration") {
      this.state.isClient = false;
      this.state.isShipDetails = false;
      this.setState({})
    }
    // dispatch(getShipnameList());
    // dispatch(getCalibrationShipCount(this.state.searchShip));
    // dispatch(getCompanynameList());
    this.getCalibrationSearchList1();
  }
  getCalibrationSearchList1 = () => {
    const { dispatch } = this.props;
    let result = {
      pageNumber: this.state.searchShip.pageNumber,
      pageSize: this.state.searchShip.pageSize,
      deviceId: this.state.searchShip.deviceId,
      // shipId: this.state.searchShip.shipId,
      shipName: this.state.searchShip.ShipName,
      clinetId: this.state.searchShip.clientId,
      make: "",
      total: this.state.searchShip.total,
      overDue: this.state.searchShip.overDue,
      thirtyDaysDue: this.state.searchShip.thirtyDaysDue,
      sixtyDaysDue: this.state.searchShip.sixtyDaysDue,
      ninetyDaysDue: this.state.searchShip.ninetyDaysDue,
      email: user.email,
      startDate: this.state.searchShip.startDate || "",
      endDate: this.state.searchShip.endDate || ""
    };

    let url = `${API.SearchCalibration}`;
    axios
      .post(url, result)
      .then((response) => {
        if (response.data) {
          dispatch({
            type: "GetCalibrationSearchSuccess",
            data: response.data,
          });
        }
        dispatch(getShipnameList());
        dispatch(getCalibrationShipCount(this.state.searchShip));
        dispatch(getCompanynameList());
      })
      .catch((error) => {
        dispatch({
          type: "GetCalibrationSearchFailure",
          error: "ERROR",
        });
        dispatch(getShipnameList());
        dispatch(getCalibrationShipCount(this.state.searchShip));
        dispatch(getCompanynameList());
      });
  }

  getCalibrationSearchList = () => {
    const { dispatch } = this.props;
    let result = {
      pageNumber: this.state.searchShip.pageNumber,
      pageSize: this.state.searchShip.pageSize,
      deviceId: this.state.searchShip.deviceId,
      // shipId: this.state.searchShip.shipId,
      shipName: this.state.searchShip.ShipName,
      clinetId: this.state.searchShip.clientId,
      make: "",
      total: this.state.searchShip.total,
      overDue: this.state.searchShip.overDue,
      thirtyDaysDue: this.state.searchShip.thirtyDaysDue,
      sixtyDaysDue: this.state.searchShip.sixtyDaysDue,
      ninetyDaysDue: this.state.searchShip.ninetyDaysDue,
      email: user.email,
      startDate: this.state.searchShip.startDate || "",
      endDate: this.state.searchShip.endDate || ""
    };

    let url = `${API.SearchCalibration}`;
    axios
      .post(url, result)
      .then((response) => {
        if (response.data) {
          dispatch({
            type: "GetCalibrationSearchSuccess",
            data: response.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "GetCalibrationSearchFailure",
          error: "ERROR",
        });
      });
  }

  SearchShips(pageNo) {
    const { dispatch } = this.props;
    this.state.searchShip.pageNumber = pageNo;
    this.getCalibrationSearchList();
  }

  exportShip() {
    let result = {
      pageNumber: this.state.searchShip.pageNumber,
      pageSize: this.state.searchShip.pageSize,
      deviceId: this.state.searchShip.deviceId,
      shipId: this.state.searchShip.shipId,
      shipName: this.state.searchShip.ShipName,
      clinetId: this.state.searchShip.clientId,
      make: "",
      total: this.state.searchShip.total,
      overDue: this.state.searchShip.overDue,
      thirtyDaysDue: this.state.searchShip.thirtyDaysDue,
      sixtyDaysDue: this.state.searchShip.sixtyDaysDue,
      ninetyDaysDue: this.state.searchShip.ninetyDaysDue,
      email: user.email,
      startDate: this.state.searchShip.startDate || "",
      endDate: this.state.searchShip.endDate || ""
    };
    let url = `${API.ExportCalibration}?DeviceId=${result.deviceId || 0}&ShipId=${result.shipId || 0}&clinetId=${result.clinetId || 0}&Make=${result.make}&ShipName=${result.shipName}&Total=${result.total}&OverDue=${result.overDue}&ThirtyDaysDue=${result.thirtyDaysDue}&SixtyDaysDue=${result.thirtyDaysDue}&NinetyDaysDue=${result.ninetyDaysDue}&email=${result.email}&StartDate=${result.startDate}&EndDate=${result.endDate}&PageNumber=${result.pageNumber}&PageSize=${result.pageSize}`;
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, "DeviceCalibrationReport_" + Moment().format("DD-MM-YYYY HH:mm") + ".xlsx");
      })
      .catch((error) => {
        console.log(error);
      });
  }


  handleAnnualSearchChange = (e, name) => {
    const { dispatch } = this.props;
    this.state.searchShip[name] = e.target.value;
    this.setState({});
  };

  handleAnnualSelectChange = (value, field, id, fieldId) => {
    const { dispatch } = this.props;
    this.state.searchShip[field] = value;
    this.state.searchShip[fieldId] = id;
    this.setState({});
  };

  ClearInput() {
    let param = {
      pageNumber: this.state.searchShip.pageNumber,
      pageSize: this.state.searchShip.pageSize,
      deviceId: "",
      shipId: 0,
      clientId: this.state.searchShip.clientId,
      ShipName: "",
      make: "",
      total: this.state.searchShip.total,
      overDue: this.state.searchShip.overDue,
      thirtyDaysDue: this.state.searchShip.thirtyDaysDue,
      sixtyDaysDue: this.state.searchShip.sixtyDaysDue,
      ninetyDaysDue: this.state.searchShip.ninetyDaysDue,
      startDate: "",
      endDate: ""

    };
    this.setState(
      {
        searchShip: param,
        SelectedManufacturingFromDate: '',
        SelectedManufacturingToDate: ''
      }, () => {
        this.getCalibrationSearchList();
      });
  }
  ClearInput1() {
    let param = {
      pageNumber: this.state.searchShip.pageNumber,
      pageSize: this.state.searchShip.pageSize,
      deviceId: "",
      shipId: 0,
      clientId: 0,
      ShipName: "",
      make: "",
      total: this.state.searchShip.total,
      overDue: this.state.searchShip.overDue,
      thirtyDaysDue: this.state.searchShip.thirtyDaysDue,
      sixtyDaysDue: this.state.searchShip.sixtyDaysDue,
      ninetyDaysDue: this.state.searchShip.ninetyDaysDue,
      startDate: "",
      endDate: ""
    };
    this.setState(
      {
        searchShip: param,
        SelectedManufacturingFromDate: '',
        SelectedManufacturingToDate: ''
      }, () => {
        this.getCalibrationSearchList();
      });
  }
  ClearInput2() {
    let param = {
      pageNumber: this.state.searchShip.pageNumber,
      pageSize: this.state.searchShip.pageSize,
      deviceId: "",
      shipId: this.state.searchShip.shipId,
      clientId: 0,
      ShipName: "",
      make: "",
      total: this.state.searchShip.total,
      overDue: this.state.searchShip.overDue,
      thirtyDaysDue: this.state.searchShip.thirtyDaysDue,
      sixtyDaysDue: this.state.searchShip.sixtyDaysDue,
      ninetyDaysDue: this.state.searchShip.ninetyDaysDue,
      startDate: "",
      endDate: ""

    };
    this.setState(
      {
        searchShip: param,
        SelectedManufacturingFromDate: '',
        SelectedManufacturingToDate: ''
      }, () => {
        this.getCalibrationSearchList();
      });
  }

  renderShipNameTitle(state, val) {
    return (state?.shipName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }
  renderClientNameTitle(state, val) {
    return (state?.clientName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }
  BacktoPrevious() {
    this.props.history.goBack();
  }
  // getCalibrationSearchList = () => {
  //   const { dispatch } = this.props;
  //   let result = {
  //     pageNumber: this.state.searchShip.pageNumber,
  //     pageSize: this.state.searchShip.pageSize,
  //     deviceId: this.state.searchShip.deviceId,
  //     // shipId: this.state.searchShip.shipId,
  //     shipName: this.state.searchShip.ShipName,
  //     clinetId: this.state.searchShip.clientId,
  //     make: "",
  //     total: this.state.searchShip.total,
  //     overDue: this.state.searchShip.overDue,
  //     thirtyDaysDue: this.state.searchShip.thirtyDaysDue,
  //     sixtyDaysDue: this.state.searchShip.sixtyDaysDue,
  //     ninetyDaysDue: this.state.searchShip.ninetyDaysDue,
  //     email: user.email,
  //     startDate: this.state.searchShip.startDate || "",
  //     endDate: this.state.searchShip.endDate || ""
  //   };

  //   let url = `${API.SearchCalibration}`;
  //   axios
  //     .post(url, result)
  //     .then((response) => {
  //       if (response.data) {
  //         dispatch({
  //           type: "GetCalibrationSearchSuccess",
  //           data: response.data,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       dispatch({
  //         type: "GetCalibrationSearchFailure",
  //         error: "ERROR",
  //       });
  //     });
  // }

  handleInputChange = (e) => {
    let nodeName = e.target.name;
    if (nodeName === "deviceId" || nodeName == "clientId") {
      this.state.searchShip[nodeName] = nodeName == "clientId" ? parseInt(e.target.value) : e.target.value;
      this.setState({})
    }

  }
  getShipDetails(action) {
    const { dispatch } = this.props;
    if (action === 1) {
      this.state.searchShip.total = true;
      this.state.searchShip.overDue = false;
      this.state.searchShip.thirtyDaysDue = false;
      this.state.searchShip.sixtyDaysDue = false;
      this.state.searchShip.ninetyDaysDue = false;
      this.setState({ action: 1 }, () => {
        this.SearchShips(1);
      });
    } else if (action === 2) {
      this.state.searchShip.total = false;
      this.state.searchShip.overDue = true;
      this.state.searchShip.thirtyDaysDue = false;
      this.state.searchShip.sixtyDaysDue = false;
      this.state.searchShip.ninetyDaysDue = false;
      this.setState({ action: 2 }, () => {
        this.SearchShips(1);
      });
    } else if (action === 3) {
      this.state.searchShip.total = false;
      this.state.searchShip.overDue = false;
      this.state.searchShip.thirtyDaysDue = true;
      this.state.searchShip.sixtyDaysDue = false;
      this.state.searchShip.ninetyDaysDue = false;
      this.setState({ action: 3 }, () => {
        this.SearchShips(1);
      });
    } else if (action === 4) {
      this.state.searchShip.total = false;
      this.state.searchShip.overDue = false;
      this.state.searchShip.thirtyDaysDue = false;
      this.state.searchShip.sixtyDaysDue = true;
      this.state.searchShip.ninetyDaysDue = false;
      this.setState({ action: 4 }, () => {
        this.SearchShips(1);
      });
    } else if (action === 5) {
      this.state.searchShip.total = false;
      this.state.searchShip.overDue = false;
      this.state.searchShip.thirtyDaysDue = false;
      this.state.searchShip.sixtyDaysDue = false;
      this.state.searchShip.ninetyDaysDue = true;
      this.setState({ action: 5 }, () => {
        this.SearchShips(1);
      });
    }

  }

  handleManufacturingFromDateChange(date) {
    this.state.searchShip.startDate = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
    this.setState({
      SelectedManufacturingFromDate: date,
      fromDatePickerManufacturingIsOpen: false
    });
  }
  handleManufacturingToDateChange(date) {
    this.state.searchShip.endDate = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
    this.setState({
      SelectedManufacturingToDate: date,
      toDatePickerManufacturingIsOpen: false
    });
  }

  handleBlur() {
    this.setState({
      manufacturingDatePickerIsOpen: false,
      fromDatePickerManufacturingIsOpen: false,
      toDatePickerManufacturingIsOpen: false
    });
  }

  openManufacturingFromDatePicker() {
    this.setState({
      toDatePickerManufacturingIsOpen: false,
      fromDatePickerManufacturingIsOpen: !this.state.fromDatePickerManufacturingIsOpen,
      /* toDatePickerLastCalibIsOpen: false,
      fromDatePickerLastCalibIsOpen: false,
      toDatePickerNextCalibIsOpen: false,
      fromDatePickerNextCalibIsOpen: false, */
    });
  };
  openManufacturingToDatePicker() {
    this.setState({
      fromDatePickerManufacturingIsOpen: false,
      toDatePickerManufacturingIsOpen: !this.state.toDatePickerManufacturingIsOpen,
      /* toDatePickerLastCalibIsOpen: false,
      fromDatePickerLastCalibIsOpen: false,
      toDatePickerNextCalibIsOpen: false,
      fromDatePickerNextCalibIsOpen: false, */
    });
  };
  render() {
    const { CalibrationShipCount, ShipNameList, CalibrationSearchList, ClientNameList } = this.props;
    const {
      total,
      overDue,
      thirtyDaysDue,
      sixtyDaysDue,
      ninetyDaysDue
    } = this.state.searchShip;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}>
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div
            className="px-3 pb-1 my-2"
            style={{ backgroundColor: "#F1F5F9", borderRadius: 14 }} >

            <div className="row py-4 px-4">
              <div className="col-lg-1"></div>
              <div className="col-lg-2">
                <div className={`${total ? "active " : ""}
                card card-selector countcard mb2 p-2 text-center`}
                  onClick={() => this.getShipDetails(1)}>
                  <h1>
                    <CountUp
                      start={0}
                      end={CalibrationShipCount.total ? CalibrationShipCount.total : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h1>
                  <h6 className="text-center">  Total Devices</h6>
                </div>
              </div>
              <div className="col-lg-2">
                <div className={`${overDue ? "active " : ""
                  }card card-selector countcard mb2 p-2 text-center`}
                  onClick={() => this.getShipDetails(2)}>
                  <h1 style={{ color: "rgb(255, 0, 0)" }}>
                    <CountUp
                      start={0}
                      end={CalibrationShipCount.overDue ? CalibrationShipCount.overDue : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h1>
                  <h6 className="text-center">Over Due</h6>
                </div>
              </div>
              <div className="col-lg-2">
                <div className={`${thirtyDaysDue ? "active " : ""
                  }card card-selector countcard mb2 p-2 text-center`}
                  onClick={() => this.getShipDetails(3)}>
                  <h1 style={{ color: "rgb(255, 130, 90)" }}>
                    <CountUp
                      start={0}
                      end={CalibrationShipCount.thirtyDaysDue ? CalibrationShipCount.thirtyDaysDue : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h1>

                  <h6 className="text-center">Due in 30 Days</h6>
                </div>
              </div>
              <div className="col-lg-2">
                <div className={`${sixtyDaysDue ? "active " : ""
                  }card card-selector countcard mb2 p-2 text-center`}
                  onClick={() => this.getShipDetails(4)}>
                  <h1 style={{ color: "rgb(255, 165, 0)" }}>
                    <CountUp
                      start={0}
                      end={CalibrationShipCount.sixstyDaysDue ? CalibrationShipCount.sixstyDaysDue : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h1>

                  <h6 className="text-center">Due in 60 Days</h6>
                </div>
              </div>
              <div className="col-lg-2">
                <div className={`${ninetyDaysDue ? "active " : ""
                  }card card-selector countcard mb2 p-2 text-center`}
                  onClick={() => this.getShipDetails(5)}>
                  <h1 style={{ color: "rgb(255, 224, 0)" }}>
                    <CountUp
                      start={0}
                      end={CalibrationShipCount.ninetyDaysDue ? CalibrationShipCount.ninetyDaysDue : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h1>
                  <h6 className="text-center">Due in 90 Days</h6>
                </div>

              </div>
              <div className="col-lg-1"></div>

            </div>

          </div>
          {/* <div className="col-12 px-3" >
            <div className="pt-4 px-2 mx-1 row">

              <div className="col-xl-4">
                <label className="label-card pbm10px">Device Search</label>
              </div>
              <div className="col-xl-8 my-auto">
                <div className="row pl-2 prd-4 mbm1rem">
                  {this.state.isShipDetails ?
                    (
                      <>
                        <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 pl-1 prd-3 prm-3">
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3">
                          <input
                            className="form-control"
                            type="text"
                            name="deviceId"
                            placeholder="Device Id"
                            onChange={(e) => this.handleInputChange(e)}
                            value={this.state.searchShip.deviceId}
                          ></input>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 mb-3">
                          <button
                            className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr"
                            type="submit"
                            onClick={() => this.SearchShips(1)}
                          >
                            {" "}
                            Search{" "}
                          </button>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 mb-3">
                          <button
                            className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn"
                            onClick={() => this.ClearInput2()}
                            type="button"   >
                            <img
                              className="mb-1"
                              src={clear}
                              width={21}
                              height={21}
                            />{" "}
                            Clear{" "}
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3">
                          <input
                            className="form-control"
                            type="text"
                            name="deviceId"
                            placeholder="Device Id"
                            onChange={(e) => this.handleInputChange(e)}
                            value={this.state.searchShip.deviceId}
                          ></input>
                        </div>

                        <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 pl-1 prd-3 prm-3">
                          <Autocomplete
                            value={this.state.searchShip.ShipName}
                            contentEditable={true}
                            inputProps={{
                              placeholder: "Ship Name",
                            }}
                            items={ShipNameList ?? []}
                            name="shipName"
                            getItemValue={(item) => item.shipName}
                            shouldItemRender={this.renderShipNameTitle.bind(this)}
                            renderMenu={(item) => (
                              <div className="dropdown">{item}</div>
                            )}
                            renderItem={(item, isHighlighted) => (
                              <div
                                className={`items ${isHighlighted ? "selected-items" : ""
                                  }`}
                              >
                                {item.shipName}
                              </div>
                            )}
                            onChange={(e) =>
                              this.handleAnnualSearchChange(e, "ShipName")
                            }
                            onSelect={(value, item) =>
                              this.handleAnnualSelectChange(
                                value,
                                "ShipName",
                                item.shipID,
                                "shipId"
                              )
                            }
                          />
                        </div>
                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 mb-3">
                          <button
                            className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr"
                            type="submit"
                            onClick={() => this.SearchShips(1)}
                          >
                            {" "}
                            Search{" "}
                          </button>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 mb-3">
                          {this.state.isClient ? (
                            <button
                              className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn"
                              onClick={() => this.ClearInput()}
                              type="button"
                            >
                              <img
                                className="mb-1"
                                src={clear}
                                width={21}
                                height={21}
                              />{" "}
                              Clear{" "}
                            </button>
                          )
                            : (
                              <button
                                className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn"
                                onClick={() => this.ClearInput1()}
                                type="button"
                              >
                                <img
                                  className="mb-1"
                                  src={clear}
                                  width={21}
                                  height={21}
                                />{" "}
                                Clear{" "}
                              </button>
                            )}
                        </div>
                      </>
                    )}

                </div>
              </div>
            </div>
          </div> */}
          {/* New search design */}
          <div className="row">
            {
              this.state.isShipDetails ?
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                      <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                        <h5 className="card-title ml-2 mt-2 f2" style={{ color: "092a51" }}>Device Search</h5>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row pb-3">
                        <div className={"col-lg-3 col-sm-12"}>
                          <label className="form-label" >Device Id</label><br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="deviceId"
                            placeholder="Device Id"
                            onChange={(e) => this.handleInputChange(e)}
                            value={this.state.searchShip.deviceId}
                          ></input>
                        </div>
                        <div className={"col-lg-3 col-sm-12"}>
                          <label className="form-label" >Next Calibration Date</label><br></br>
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="input-group add-on date datepicker" data-date-format="yyyy-mm-dd">
                                <input
                                  type="text"
                                  value={this.state.searchShip?.startDate}
                                  className="form-control date-picker"
                                  placeholder="From"
                                  name="manufacturingDate"
                                ></input>
                                <DatePicker
                                  selected={this.state.SelectedManufacturingFromDate}
                                  onChange={this.handleManufacturingFromDateChange}
                                  onClickOutside={this.handleBlur}
                                  open={this.state.fromDatePickerManufacturingIsOpen}
                                  startDate={this.state.SelectedManufacturingFromDate}
                                  maxDate={this.state.SelectedManufacturingToDate}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  popperPlacement={`${this.state.isMobile ? "top-end" : "bottom"}`}
                                  className="form-control date-picker w-5 hide-date" />
                                <div
                                  className="input-group-btn calendar-icon"
                                  onClick={this.openManufacturingFromDatePicker}>
                                  <button className="btn btn-default" style={{ height: "100%" }}>
                                    <i className="fa fa-calendar mt-1"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6 margin">
                              <div className="input-group add-on date datepicker" data-date-format="yyyy-mm-dd">
                                <input
                                  type="text"
                                  value={this.state.searchShip?.endDate}
                                  className="form-control date-picker"
                                  placeholder="To"
                                  name="manufacturingDate"
                                ></input>
                                <DatePicker selected={this.state.SelectedManufacturingToDate}
                                  onClickOutside={this.handleBlur}
                                  onChange={this.handleManufacturingToDateChange}
                                  open={this.state.toDatePickerManufacturingIsOpen}
                                  endDate={this.state.SelectedManufacturingToDate}
                                  minDate={this.state.SelectedManufacturingFromDate}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  popperPlacement="top-end"
                                  className="form-control date-picker w-5 hide-date" />
                                <div
                                  className="input-group-btn calendar-icon"

                                  onClick={this.openManufacturingToDatePicker}
                                >
                                  <button className="btn btn-default" style={{ height: "100%" }}>
                                    <i className="fa fa-calendar mt-1"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={"col-lg-3 col-sm-12"}></div>
                        <div className={"col-lg-3 col-sm-12 pt-3"}>
                          <br></br>
                          <div className="search-btn-col" style={{ textAlign: "end" }}>
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit" onClick={() => this.SearchShips(1)}>
                              {" "}Search  {" "}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button" onClick={() => this.ClearInput2()}>
                              {" "} Clear{" "}
                            </button>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div> : <div className="col-lg-12">
                  <div className="panel-box">
                    <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                      <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                        <h5 className="card-title ml-2 mt-2 f2" style={{ color: "092a51" }}>Device Search</h5>

                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row pb-3">
                        <div className={"col-lg-2 col-sm-12"}>
                          <label className="form-label" >Device Id</label><br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="deviceId"
                            placeholder="Device Id"
                            onChange={(e) => this.handleInputChange(e)}
                            value={this.state.searchShip.deviceId}
                          ></input>
                        </div>
                        <div className={"col-lg-3 col-sm-12"}>
                          <label className="form-label" >Ship Name</label><br></br>
                          <div className="autocomplete-wrappers mb-3 pl-1 prd-3 prm-3">
                            <Autocomplete
                              value={this.state.searchShip.ShipName}
                              contentEditable={true}
                              inputProps={{
                                placeholder: "Ship Name",
                              }}
                              items={ShipNameList ?? []}
                              name="shipName"
                              getItemValue={(item) => item.shipName}
                              shouldItemRender={this.renderShipNameTitle.bind(this)}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${isHighlighted ? "selected-items" : ""
                                    }`}
                                >
                                  {item.shipName}
                                </div>
                              )}
                              onChange={(e) =>
                                this.handleAnnualSearchChange(e, "ShipName")
                              }
                              onSelect={(value, item) =>
                                this.handleAnnualSelectChange(
                                  value,
                                  "ShipName",
                                  item.shipID,
                                  "shipId"
                                )
                              }
                            />
                          </div>
                        </div>
                        <div className={"col-lg-4 col-sm-12"}>
                          <label className="form-label" >Next Calibration Date</label><br></br>
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="input-group add-on date datepicker" data-date-format="yyyy-mm-dd">
                                <input
                                  type="text"
                                  value={this.state.searchShip?.startDate}
                                  className="form-control date-picker"
                                  placeholder="From"
                                  name="manufacturingDate"
                                ></input>
                                <DatePicker
                                  selected={this.state.SelectedManufacturingFromDate}
                                  onChange={this.handleManufacturingFromDateChange}
                                  onClickOutside={this.handleBlur}
                                  open={this.state.fromDatePickerManufacturingIsOpen}
                                  startDate={this.state.SelectedManufacturingFromDate}
                                  maxDate={this.state.SelectedManufacturingToDate}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  popperPlacement={`${this.state.isMobile ? "top-end" : "bottom"}`}
                                  className="form-control date-picker w-5 hide-date" />
                                <div
                                  className="input-group-btn calendar-icon"
                                  onClick={this.openManufacturingFromDatePicker}>
                                  <button className="btn btn-default" style={{ height: "100%" }}>
                                    <i className="fa fa-calendar mt-1"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6 margin">
                              <div className="input-group add-on date datepicker" data-date-format="yyyy-mm-dd">
                                <input
                                  type="text"
                                  value={this.state.searchShip?.endDate}
                                  className="form-control date-picker"
                                  placeholder="To"
                                  name="manufacturingDate"
                                ></input>
                                <DatePicker selected={this.state.SelectedManufacturingToDate}
                                  onClickOutside={this.handleBlur}
                                  onChange={this.handleManufacturingToDateChange}
                                  open={this.state.toDatePickerManufacturingIsOpen}
                                  endDate={this.state.SelectedManufacturingToDate}
                                  minDate={this.state.SelectedManufacturingFromDate}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  popperPlacement="top-end"
                                  className="form-control date-picker w-5 hide-date" />
                                <div
                                  className="input-group-btn calendar-icon"

                                  onClick={this.openManufacturingToDatePicker}
                                >
                                  <button className="btn btn-default" style={{ height: "100%" }}>
                                    <i className="fa fa-calendar mt-1"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {
                          window.location.href.indexOf("Management/DeviceCalibration") > -1 ? <div className={"col-lg-3 col-sm-12"}>
                            <label className="form-label" >Company Name</label>
                            <br></br>
                            {/* <select
                              className="form-control"
                              name="clientId"
                              value={this.state.searchShip.clientId}
                              onChange={(e) => this.handleInputChange(e)}
                            >
                              <option value="">Select Company Name</option>
                              {ClientNameList &&
                                ClientNameList.map((i) => (
                                  <option value={i.clientID}>{i.clientName}</option>
                                ))}
                            </select> */}
                            <div className="autocomplete-wrappers mb-3 pl-1 prd-3 prm-3">
                              <Autocomplete
                                value={this.state.searchShip.clientName}
                                contentEditable={true}
                                inputProps={{
                                  placeholder: "Company Name",
                                }}
                                items={ClientNameList ?? []}
                                name="clientName"
                                getItemValue={(item) => item.clientName}
                                shouldItemRender={this.renderClientNameTitle.bind(this)}
                                renderMenu={(item) => (
                                  <div className="dropdown">{item}</div>
                                )}
                                renderItem={(item, isHighlighted) => (
                                  <div
                                    className={`items ${isHighlighted ? "selected-items" : ""
                                      }`}
                                  >
                                    {item.clientName}
                                  </div>
                                )}
                                onChange={(e) =>
                                  this.handleAnnualSearchChange(e, "clientName")
                                }
                                onSelect={(value, item) =>
                                  this.handleAnnualSelectChange(
                                    value,
                                    "clientName",
                                    item.clientID,
                                    "clientId"
                                  )
                                }
                              />
                            </div>
                          </div> : ''
                        }
                        <div className={"col-lg-12 col-sm-12 pt-3"}>
                          <br></br>
                          <div className="search-btn-col" style={{ textAlign: "end" }}>
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit" onClick={() => this.SearchShips(1)}>
                              {" "}Search  {" "}
                            </button>
                            {this.state.isClient ? (
                              <button
                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                type="button" onClick={() => this.ClearInput()}>
                                {" "} Clear{" "}
                              </button>
                            )
                              : (
                                <button
                                  className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                  type="button" onClick={() => this.ClearInput1()}>
                                  {" "} Clear{" "}
                                </button>
                              )}
                            {
                              !this.state.isClient && window.location.href.indexOf("Management/DeviceCalibration") > -1 ? <button
                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                type="submit" onClick={() => this.exportShip()}>
                                {" "}Export Excel{" "}
                              </button> : ""
                            }
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
            }
          </div>
          {CalibrationSearchList ? (
            <div id="textbody">
              <MMPLCalibrationDueList
                arraylist={CalibrationSearchList.data}
                pageSize={CalibrationSearchList?.pagination?.pageSize}
                totalRecords={
                  CalibrationSearchList?.pagination?.totalcount
                    ? CalibrationSearchList?.pagination?.totalcount
                    : 0
                }
                setUpdatedState={(value) => this.SearchShips(value)}
              />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ShipNameList: state.UserManageReducer.ShipNameList || [],
    showSidePane: state.SidePanReducer.sidePan || false,
    CalibrationSearchList: state.MasterScreenReducer.CalibrationSearchList || [],
    CalibrationShipCount: state.MasterScreenReducer.CalibrationShipCount || [],
    ClientNameList: state.UserManageReducer.CompanyList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceCalibrationSearch);
